var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 19,
    viewBox: "0 0 24 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.998 11.812L9.51104 9.75024L0.83429 18.6325H22.9413L14.4243 9.73525L11.998 11.812ZM15.6656 8.79251L23.917 17.3718C23.9643 17.2053 23.998 17.0328 23.998 16.8505V2.0215L15.6656 8.79251ZM-0.00195312 1.98701V16.8505C-0.00195312 17.0328 0.0317982 17.2053 0.0790482 17.3718L8.3583 8.82025L-0.00195312 1.98701ZM23.248 0.625H0.748047L11.998 9.63926L23.248 0.625Z",
    fill: "#FFB85C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.7816d0683f92f3d0c00784e9f2c5ae31.svg";
export { ForwardRef as ReactComponent };